export enum SearchPageLayout {
    FilterLeftResultsRight,
    FilterRightResultsLeft
}
